import { jarvisApi } from './jarvis-api'
import store from '../store/store'

export default class MatterApi {
  static getAllMatters (status) {
    let archived = 0
    if (status === 'close') {
      archived = 1
    }
    return jarvisApi.get(
      '/contact-portal-user/' + store.getters.currentUser.id + '/matters/law-firm-id/' + store.getters.currentLawFirm.id,
      {
        params:
          {
            archived: archived
          }
      }
    ).then(res => {
      return res.data.map(matter => {
        matter.creation_date = new Date(matter.creation_date)

        return matter
      })
    })
  }
}
